<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1 bt-blue500 hidden-card">
                <maximize-and-minimize></maximize-and-minimize>
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Pesquisar</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label for="channel"
                                    >Árvore de sortimento</label
                                >
                                <md-input
                                    name="node"
                                    id="node"
                                    value=""
                                    style="cursor: pointer;"
                                    v-model="filterNodeName"
                                    @click="treeModalOpen(true)"
                                    readonly
                                >
                                </md-input>
                                <md-icon>account_tree</md-icon>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Fornecedor</label>
                                <md-input
                                    type="text"
                                    v-model="filterProvider"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label>Produto</label>
                                <md-input
                                    type="text"
                                    v-model="filterProduct"
                                ></md-input>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label for="status">Status</label>
                                <md-select
                                    name="status"
                                    id="status"
                                    v-model="filterStatus"
                                    placeholder="Todos"
                                    multiple
                                >
                                    <md-option
                                        v-for="(status, index) in statusList"
                                        v-bind:key="`status-${index}`"
                                        :value="status.status"
                                    >
                                        {{ status.text }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-danger md-sm ml-1"
                                @click="clearFilter()"
                            >
                                Limpar
                            </md-button>
                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item">
            <md-card v-if="!filterLoading">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>local_offer</md-icon>
                    </div>
                    <h4 class="title"></h4>
                    <div style="text-align: right">
                        <md-button
                            class="md-primary md-sm"
                            style="margin: 20px 20px 0 20px"
                            @click.native="editOpen()"
                        >
                            Adicionar
                        </md-button>
                        <md-button
                            class="md-just-icon md-simple"
                            style="float:right; margin: 10px 0 0 0"
                            @click.native="handleColumnsEdit()"
                        >
                            <md-icon>settings</md-icon>
                        </md-button>
                        <!--
                        <div style="float: right;">
                            <md-field>
                                <md-input
                                    type="search"
                                    clearable
                                    style="width: 200px"
                                    placeholder="Filtrar"
                                    v-model="searchQuery"
                                >
                                </md-input>
                            </md-field>
                        </div>
                        -->
                    </div>
                </md-card-header>
                <md-card-content>
                    <md-table
                        :value="queriedData.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        class="paginated-table table-striped table-hover"
                    >
                        <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            @mouseenter="actionVisible = item.id"
                            @mouseleave="actionVisible = null"
                        >
                            <md-table-cell
                                v-for="column in visibleColumns"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="showColumn(column, item)"
                            >
                                {{ showColumn(column, item) }}
                            </md-table-cell>
                            <md-table-cell class="td-actions">
                                <div v-if="actionVisible == item.id">
                                    <md-button
                                        class="md-just-icon md-primary md-simple"
                                        @click="
                                            moveToProductSimulation(item.id)
                                        "
                                    >
                                        <md-icon>outbond</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-primary md-simple"
                                        @click="viewOpen(item)"
                                    >
                                        <md-icon>open_in_browser</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-warning md-simple"
                                        @click="editOpen(item)"
                                    >
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-danger md-simple"
                                        @click.native="handleDelete(item)"
                                    >
                                        <md-icon>close</md-icon>
                                    </md-button>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando
                            <select
                                id="numberItemPage"
                                v-model="pagination.perPage"
                            >
                                <option value="20">20</option>
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                            itens de um total de {{ this.queriedData.count }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>
            </md-card>
            <md-card v-else>
                <md-card-content>
                    <div class="text-center mt-2 pb-2 ">
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <modal v-if="viewModal" @close="viewCancel()">
            <template slot="header">
                <h4 class="modal-title">Detalhes</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="viewCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-small-size-100 md-size-100"
                        v-for="column in Object.keys(showColumns)"
                        :key="column"
                    >
                        <b>{{ columnNames[column] }}:</b>

                        {{ showColumn(column, editModalModel) }}
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="viewCancel()">
                    Fechar
                </md-button>
            </template>
        </modal>

        <form @submit.prevent="editSubmit()">
            <modal v-if="editModal" @close="editCancel()">
                <template slot="header">
                    <h4 class="modal-title">{{ editModalTitle }}</h4>
                    <md-button
                        class="md-simple md-just-icon md-round modal-default-button"
                        @click="editCancel()"
                    >
                        <md-icon>clear</md-icon>
                    </md-button>
                </template>

                <template slot="body">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            v-for="field in editableFields"
                            :key="field"
                        >
                            <md-field v-if="field == 'master_box_type'">
                                <label> {{ columnNames[field] }} </label>
                                <md-select
                                    name="masterBoxType"
                                    id="masterBoxType"
                                    v-model="editModalModel['master_box_type']"
                                    placeholder=""
                                >
                                    <md-option
                                        v-for="(type, index) in masterBoxTypes"
                                        v-bind:key="`type-${index}`"
                                        :value="type.id"
                                    >
                                        {{ type.value }}
                                    </md-option>
                                </md-select>
                            </md-field>
                            <md-field
                                v-if="
                                    fieldTypes[field] != 'datetime-local' &&
                                        field != 'master_box_type'
                                "
                            >
                                <label>{{ columnNames[field] }}</label>
                                <md-input
                                    v-model="editModalModel[field]"
                                    :type="fieldTypes[field]"
                                ></md-input>
                            </md-field>
                            <md-datepicker
                                v-model="editModalModel[field]"
                                v-if="
                                    fieldTypes[field] == 'datetime-local' &&
                                        field != 'master_box_type'
                                "
                                md-immediately
                            >
                                <label>{{ columnNames[field] }}</label>
                            </md-datepicker>
                        </div>
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 7px;"
                        >
                            <label class="artificial-label">
                                Cor
                            </label>
                            <vue-simple-suggest
                                v-model="colorModel"
                                :list="colorList"
                                :debounce="500"
                                display-attribute="name"
                                value-attribute="id"
                                @select="colorSelected"
                            >
                            </vue-simple-suggest>
                        </div>
                        <div
                            class="md-layout-item md-small-size-100 md-size-100"
                            style="overflow-x: visible; margin-bottom: 7px;"
                        >
                            <label class="artificial-label">
                                Produto Similar
                            </label>
                            <vue-simple-suggest
                                v-model="similarProductModel"
                                :list="similarProductsList"
                                :debounce="500"
                                display-attribute="name"
                                value-attribute="id"
                                @select="similarProductSelected"
                            >
                            </vue-simple-suggest>
                        </div>
                    </div>
                </template>

                <template slot="footer">
                    <md-button class="md-simple" @click="editCancel()">
                        Cancelar
                    </md-button>
                    <md-button class="md-primary" type="submit">
                        Salvar
                    </md-button>
                </template>
            </modal>
        </form>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(showColumns)"
                        v-model="showColumns[column]"
                        :key="column"
                    >
                        {{ columnNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>

        <!-- Modal to select tree node -->
        <modal v-if="treeModal" @close="treeModalOpen(false)" width="500px">
            <template slot="header">
                <h4 class="modal-title">
                    Item da árvore de sortimento
                </h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                ></v-draggable-treeview>
            </template>

            <template slot="footer">
                <div>
                    <p class="card-category">
                        Mostrando itens {{ nodeFrom }} a {{ nodeTo }} de um
                        total de {{ nodeTotal }}.
                    </p>
                </div>
                <pagination
                    class="pagination-no-border pagination-success"
                    v-model="nodePagination.currentPage"
                    :per-page="nodePagination.perPage"
                    :total="nodeTotal"
                >
                </pagination>
            </template>
        </modal>

        <!-- Modal Create New Branch Parameter -->
        <modal v-if="branchParamsModal" @close="viewCancel()">
            <template slot="header">
                <h4 class="modal-title">
                    Novos parâmetros de filial
                </h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="viewCancel()"
                    :disabled="createParameterLoading"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-small-size-100 md-size-100"
                        v-for="field in newParameterFields"
                        :key="field"
                    >
                        <md-field v-if="newFieldTypes[field] === 'select'">
                            <md-select
                                v-if="
                                    field === 'branch_channel' ||
                                        field === 'dc_channel'
                                "
                                v-model="newParameterModalModel[field]"
                                placeholder="Canal"
                                :disabled="createParameterLoading"
                            >
                                <md-option
                                    v-for="channel in Object.keys(
                                        branchChannels
                                    )"
                                    v-bind:key="`channel-${channel}`"
                                    :value="channel"
                                >
                                    {{ branchChannels[channel] }}
                                </md-option>
                            </md-select>
                        </md-field>

                        <div v-else-if="newFieldTypes[field] === 'text'">
                            <md-field>
                                <label>{{ paramsColumnNames[field] }}</label>
                                <md-input
                                    v-model="newParameterModalModel[field]"
                                    :type="newFieldTypes[field]"
                                    :disabled="createParameterLoading"
                                ></md-input>
                            </md-field>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button
                    class="md-simple"
                    @click="viewCancel()"
                    :disabled="createParameterLoading"
                >
                    Cancelar
                </md-button>
                <md-button
                    class="md-primary"
                    type="submit"
                    @click="handleBranchParameter()"
                    :disabled="createParameterLoading"
                >
                    {{
                        currentStepNewParameterFields === 'branch'
                            ? 'Próximo'
                            : 'Finalizar'
                    }}
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Pagination, Modal, VuetifyDraggableTreeview } from '@/components'
import Swal from 'sweetalert2'
import { mapState, mapActions } from 'vuex'
import VueSimpleSuggest from 'vue-simple-suggest'

import { ProductService } from '@/services/product.service'
import { Product as Model } from '@/models/product.model'
import { NewBranchParameter } from '@/models/branchparameter.model'
import { NewDCParameter } from '@/models/dcparameter.model'
import Node from '@/models/node.model'

const model = 'products'
import MaximizeAndMinimize from '@/components/Maximize/MaximizeAndMinimize.vue'

export default {
    created() {
        this.clearFilter()
        this.readEntities()
    },
    components: {
        Pagination,
        Modal,
        VueSimpleSuggest,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        MaximizeAndMinimize
    },
    computed: {
        ...mapState({
            queriedData: state => state[model].page,
            filterLoading: state => state[model].filterLoading,
            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors
        }),
        to() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[
                    this.queriedData.results.length - 1
                ].id
            else return 0
        },
        from() {
            if (this.queriedData.results.length > 0)
                return this.queriedData.results[0].id
            else return 0
        },
        total() {
            return this.queriedData.count
        },
        visibleColumns() {
            let columns = []
            Object.keys(this.showColumns).forEach(key => {
                if (this.showColumns[key]) columns.push(key)
            })
            return columns
        },
        statusList() {
            return Object.keys(this.status).map(key => this.status[key])
        },

        treeData() {
            return [{ name: 'Todos os itens', id: null }] //this.treePage.results
        },
        nodeTo() {
            if (this.treePage.results.length > 0)
                return this.treePage.results[this.treePage.results.length - 1]
                    .id
            else return 0
        },
        nodeFrom() {
            if (this.treePage.results.length > 0)
                return this.treePage.results[0].id
            else return 0
        },
        nodeTotal() {
            return this.treePage.count
        },

        newParameterFields() {
            return this.currentStepNewParameterFields === 'branch'
                ? Object.keys(NewBranchParameter.createFields)
                : Object.keys(NewDCParameter.createFields)
        }
    },
    data() {
        return {
            viewModal: false,
            editModalTitle: '',
            editModalModel: new Model(),
            editModal: false,
            columnsModal: false,
            showColumns: Model.visibleFields,
            columnNames: Model.fieldNames,
            editableFields: Object.keys(Model.editableFields).filter(
                item => ['similar_product', 'color'].indexOf(item) == -1
            ),
            fieldTypes: Model.fieldTypes,
            currentSort: 'id',
            currentSortOrder: 'asc',
            searchQuery: '',
            pagination: {
                perPage: 20,
                currentPage: 1,
                total: 0
            },
            status: Model.status,

            filterStatus: [],
            filterNode: new Node(),
            filterNodeName: 'Todos os itens',
            filterProduct: '',
            filterProvider: '',

            treeModal: false,
            nodePagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            },
            status_obj: {
                P: 'Candidato',
                A: 'Ativo',
                D: 'Em descontinuação',
                O: 'Descontinuado',
                I: 'Inativo'
            },
            actionVisible: null,

            similarProductModel: '',
            colorModel: '',

            masterBoxTypes: [
                {
                    id: 1,
                    value: 'Não tem'
                },
                {
                    id: 2,
                    value: 'Tem'
                },
                {
                    id: 3,
                    value: 'Pode ter'
                }
            ],

            branchParamsModal: false,
            productId: null,
            newParameterModalModel: {
                branch_channel: 'R',
                branch_showcase_items: 1,
                branch_stack_items: 0,
                branch_coverage: 7,
                branch_coverage_max: 25,
                branch_stock_max: 0,
                branch_cost: 0,
                branch_price: 0,
                dc_channel: 'R',
                dc_cost: 0,
                dc_price: 0,
                dc_coverage_period: 15,
                dc_coverage_safety: 7,
                dc_upper_limit_stock_reserve: null,
                dc_lower_limit_stock_reserve: null
            },

            newFieldTypes: {
                ...NewBranchParameter.fieldTypes,
                ...NewDCParameter.fieldTypes
            },

            currentStepNewParameterFields: 'branch',
            paramsColumnNames: {
                ...NewBranchParameter.fieldNames,
                ...NewDCParameter.fieldNames
            },
            branchChannels: {
                R: 'Varejo',
                W: 'Atacado',
                E: 'E-commerce'
            },

            createParameterLoading: false
        }
    },
    methods: {
        ...mapActions(model, {
            createEntity: 'create',
            readEntities: 'read',
            updateEntity: 'update',
            deleteEntity: 'delete'
        }),
        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),
        ...mapActions('products', {
            createParameter: 'createParameter'
        }),
        ...mapActions('simulations', {
            canSimulate: 'canSimulate'
        }),
        showColumn(column, item) {
            return column == 'status'
                ? this.status_obj[item[column]]
                : column == 'color'
                ? item[column] && item[column].name
                    ? item[column].name
                    : 'SEM COR'
                : item[column]
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },
        columnsCancel() {
            this.columnsModal = false
        },

        viewOpen(item) {
            this.editModalModel = {
                ...this.editModalModel,
                ...item
            }
            this.viewModal = true
        },
        viewCancel() {
            this.viewModal = false
            this.editModalModel = new Model()
            this.branchParamsModal = false
        },

        async similarProductsList() {
            let products = await ProductService.read({
                q: this.similarProductModel
            })
                .then(res => res.data)
                .then(json => json.results)
            products = products.map(item => {
                item.name = item.external_id + ' - ' + item.name
                return item
            })
            return products
        },
        async similarProductUpdate() {
            if (!this.editModalModel.similar_product) return
            let product = await ProductService.read(
                this.editModalModel.similar_product
            ).then(res => res.data)
            this.similarProductModel =
                product.external_id + ' - ' + product.name
        },
        similarProductSelected(selectedItem) {
            this.editModalModel['similar_product'] = selectedItem.id
        },

        async colorList() {
            let colors = await ProductService.readColors({
                q: this.colorModel
            })
                .then(res => res.data)
                .then(json => json.results)
            colors = colors.map(item => {
                item.name = item.external_id + ' - ' + item.name
                return item
            })
            return colors
        },
        async colorUpdate() {
            if (this.editModalModel.color) {
                this.colorModel =
                    this.editModalModel.color.external_id +
                    ' - ' +
                    this.editModalModel.color.name
                this.editModalModel.color = this.editModalModel.color.id
            } else this.colorModel = null
        },
        colorSelected(selectedItem) {
            this.editModalModel['color'] = selectedItem.id
        },

        editOpen(item) {
            if (item) {
                this.editModalTitle = 'Editando #' + item.id
                // copy object values
                this.editModalModel = {
                    ...new Model(),
                    ...item
                }
                // update similar product select
                this.similarProductUpdate()
                this.colorUpdate()
            } else {
                this.editModalTitle = 'Novo produto'
            }
            this.editModal = true
        },
        editCancel() {
            this.editModal = false
            this.editModalModel = new Model()
        },
        async editSubmit() {
            let editError

            if (this.editModalModel.id) {
                editError = await this.updateEntity({
                    ...this.editModalModel
                })
            } else {
                editError = await this.createEntity({
                    ...this.editModalModel
                })
            }

            if (editError)
                this.$notify({
                    message:
                        'Erro ao ' +
                        (this.editModalModel.id ? 'editar' : 'criar') +
                        ' produto.',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            else {
                this.$notify({
                    message:
                        'Produto ' +
                        (this.editModalModel.id ? 'editado' : 'criado') +
                        ' com sucesso!',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'success'
                })

                this.editModal = false
                this.editModalModel = new Model()
                this.readEntities()
            }
        },

        handleDelete(item) {
            Swal.fire({
                title: 'Certeza?',
                text: 'Esta ação é irreversível.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-danger btn-fill',
                cancelButtonClass: 'md-button md-simple',
                confirmButtonText: 'Sim, remover!',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    let deleteError = await this.deleteEntity({ id: item.id })

                    if (deleteError)
                        this.$notify({
                            message: 'Erro ao remover.',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'danger'
                        })
                    else {
                        this.$notify({
                            message: 'Removido com sucesso!',
                            icon: 'add_alert',
                            horizontalAlign: 'right',
                            verticalAlign: 'bottom',
                            type: 'success'
                        })
                        this.readEntities()
                    }
                }
            })
        },

        treeModalOpen(state) {
            this.treeModal = state
        },
        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },
        async selectTreeChild(item) {
            this.filterNode = item
            //this.selectedNodeName = 'Carregando árvore...'
            this.treeModal = false
            await this.readTreeAncestors({ id: item.id })

            if (item.id == null) {
                this.filterNodeName = 'Todos os itens'
                this.treeModal = false
            } else {
                this.filterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.filterNodeName += ' > '
                    this.filterNodeName += ancestor.name
                })
            }
        },

        applyFilter() {
            let args = {
                status: this.filterStatus.join('|'),
                parent: this.filterNode['id'],
                name: this.filterProduct,
                brand: this.filterProvider,
                page: 1,
                limit: this.pagination.perPage
            }
            this.pagination.currentPage = 1
            this.readEntities(args)
        },

        clearFilter() {
            this.filterProvider = ''
            this.filterProduct = ''
            this.filterStatus = []
            this.filterNode = new Node()
            this.filterNodeName = 'Todos os itens'
        },

        async moveToProductSimulation(id) {
            // check can simulate
            const response = await this.canSimulate(id)

            if (Object.keys(response).length === 0) {
                this.$router.push('/product-simulation/' + id)
            } else if (response.detail === 'Cannot simulate!') {
                this.productId = id
                this.branchParamsModal = true
            }
        },

        async handleBranchParameter() {
            if (this.currentStepNewParameterFields === 'branch') {
                this.currentStepNewParameterFields = 'dc'
            } else {
                this.createParameterLoading = true
                const response = await this.createParameter({
                    ...this.newParameterModalModel,
                    product_id: this.productId
                })
                this.createParameterLoading = false
                if (response !== 500 && response !== 400) {
                    this.$router.push('/product-simulation/' + this.productId)
                } else {
                    this.$notify({
                        message: 'Erro ao criar novos parâmetros.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                }
            }
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                if (val.perPage) val.perPage = parseInt(val.perPage)
                this.readEntities({
                    status: this.filterStatus.join('|'),
                    parent: this.filterNode['id'],
                    name: this.filterProduct,
                    brand: this.filterProvider,
                    page: val.currentPage,
                    limit: this.pagination.perPage
                })
            },
            deep: true
        }
    }
}
</script>

<style>
.vue-simple-suggest.designed .input-wrapper input {
    border-radius: 0 !important;
    padding: 7px 0 !important;
    font-size: 14px !important;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif !important;
    -webkit-text-fill-color: #3c4858 !important;
    border: none !important;
    border-bottom: 1px solid #ccc !important;
}

.vue-simple-suggest.designed .input-wrapper input:focus {
    border: none !important;
    border-bottom: 2px solid #448aff !important;
}
</style>
<style lang="css" scoped>
.artificial-label {
    color: #aaaaaa !important;
    font-weight: 400;
    font-size: 0.6875rem;
    line-height: 1.4;
}

.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}

.modal-wrapper .md-checkbox {
    display: flex !important;
}

.md-table-cell {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
